import { apiGet } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const OccupantNumberDropdown = (props) => {
  const { onChange, defaultValue, name, numberOption } = props;

  const handleDropdownChange = (value) => {
    const selectedOption = numberOption.find((option) => option.id == value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue || undefined}
      placeholder="Select by occupant number"
      options={numberOption}
      onChange={handleDropdownChange}
      borderColor="#ED850C"
      disabled={true}
      width="220px"
    />
  );
};

export default OccupantNumberDropdown;
